const getFullUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http') || url.startsWith('https')) return url;
    // Derive base from API URL, stripping /api suffix
    const apiUrl = process.env.REACT_APP_API_URL || 'https://api.aryasabhyata.org/api';
    const baseUrl = (process.env.REACT_APP_IMAGE_BASE_URL || apiUrl.replace(/\/api\/?$/, '')).replace(/\/$/, '');
    const cleanUrl = url.startsWith('/') ? url : `/${url}`;
    return `${baseUrl}${cleanUrl}`;
};

export default getFullUrl;
